module.exports = __webpack_public_path__ + "static/img/10.818f9bb.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/4/2/sp/10.png
// module id = 8zKy
// module chunks = 0